/* eslint-disable no-underscore-dangle */
import {getParentComponent, getChildComponent, getBrotherComponent, getComponentName} from './linktools';

export default {
    install(Vue) {

        /**
         * @method：$getComponentName
         * @createdBy:HuangJian
         * @date:2018/11/17
         * @params：
         * @description：获取组件名称
         */
        Vue.prototype.$getComponentName = getComponentName;

        /**
         * @method：$getParentComponent
         * @createdBy:HuangJian
         * @date:2018/11/17
         * @params：
         * componentName：组件名（单个）
         * componentNames：组件名（多个）
         * @description：获取父组件
         */
        Vue.prototype.$getParentComponent = function(componentName, componentNames){
            return getParentComponent(this, componentName, componentNames);
        };


        /**
         * @method：getChildComponent
         * @createdBy:HuangJian
         * @date:2018/11/17
         * @params：
         * componentName：组件名
         * findonce：是否只返回一个实例（默认为是）
         * @description：获取子组件
         */

        Vue.prototype.$getChildComponent = function(componentName, findonce){
            return getChildComponent(this, componentName, findonce);
        };

        /**
         * @method：$getBrotherComponent
         * @createdBy:HuangJian
         * @date:2018/11/20
         * @params：
         * componentName:组件名
         * findonce：是否只返回一个实例（默认为是）
         * @description：获取兄弟组件
         */
        Vue.prototype.$getBrotherComponent = function(componentName, findonce){
            return getBrotherComponent(this, componentName, findonce);
        };
        /**
         * @method：$dispatch
         * @createdBy:HuangJian
         * @date:2018/11/17
         * @params：
         * componentName：组件名
         * eventName：事件名
         * params：参数
         * @description：与父级组件通信（冒泡消息）
         */
        Vue.prototype.$dispatch = function (componentName, eventName, ...params) {
            const parent = getParentComponent(this, componentName) || {};
            if (parent._isVue) {
                parent.$emit(...[eventName].concat([...params]));
            }
        };

        /**
         * @method：$broadcast
         * @createdBy:HuangJian
         * @date:2018/11/17
         * @params：
         * componentName：组件名
         * eventName：事件名
         * params：参数
         * @description：与子组件通信（广播消息）
         */
        Vue.prototype.$broadcast = function(componentName, eventName, ...params){
            const children = getChildComponent(this, componentName, false) || [];
            children.forEach((child) => {
                if (child._isVue) {
                    child.$emit(...[eventName].concat([...params]));
                }
            });
        };

        /**
         * @method：$deliver
         * @createdBy:HuangJian
         * @date:2018/11/20
         * @params：
         * componentName：组件名
         * eventName：事件名
         * params：参数
         * @description：与兄弟组件通信
         */
        Vue.prototype.$deliver = function(componentName, eventName, ...params){
            const brothers = getBrotherComponent(this, componentName, false) || [];
            brothers.forEach((brother) => {
                if (brother._isVue) {
                    brother.$emit(...[eventName].concat([...params]));
                }
            });
        };

    }
};
